"use client";

import React from "react";
import { ArrowRight, Bot, Car, GraduationCap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const nextSteps = [{
  title: "Derinlemesine Hijyen",
  description: "Diş eti sağlığını korumak için tartar ve plakların nazikçe temizlenmesi.",
  iconId: "car",
  url: "/GumTreatmentsPage"
}, {
  title: "Uzman Değerlendirmesi",
  description: "Periodontal sağlığınızın uzman hekimlerimizce detaylı analizi.",
  iconId: "bot",
  url: "/TreatmentsPage"
}, {
  title: "Profesyonel Parlatma",
  description: "Diş yüzeylerini pürüzsüzleştirerek doğal beyazlığın ortaya çıkarılması.",
  iconId: "academy",
  url: "/TeethWhiteningPage"
}];
export default function InformationAndNavigation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const renderIcon = (iconId: string) => {
    switch (iconId) {
      case "car":
        return <Car className="size-6 text-primary" />;
      case "bot":
        return <Bot className="size-6 text-primary" />;
      case "academy":
        return <GraduationCap className="size-6 text-primary" />;
      default:
        return <ArrowRight className="size-6 text-primary" />;
    }
  };
  return <section data-section-id="149272" id="what-is-dental-scaling" className="bg-background py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {}
          <div className={`flex flex-col gap-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-serif font-semibold tracking-tight text-foreground">
                Diş Taşı Temizliği Nedir?
              </h2>
              <p className="text-lg font-sans text-muted-foreground leading-[1.6] max-w-xl">Diş taşı temizliği, dişlerinizde ve diş eti çizgisinde biriken sertleşmiş plağın (tartar) profesyonelce uzaklaştırılması işlemidir. Modern kliniğimizde, gelişmiş ultrasonik cihazlar kullanarak diş eti sağlığınızı üst düzeyde koruyor ve ağız hijyeninizi yeniden yapılandırıyoruz.</p>
            </div>
            
            <div className="pt-4">
              <Button asChild size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground rounded-none px-8">
                <Link to="/ContactPage">
                  Randevu Alın
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            {nextSteps.map((step, i) => <div key={step.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${i * 150}ms`
          }}>
                <Link to={step.url} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-none">
                  <Card className="transition-all duration-300 hover:shadow-md border-primary/20 hover:border-primary/50 bg-card/40 backdrop-blur-sm rounded-none">
                    <CardContent className="p-6 flex items-start gap-4">
                      <div className="shrink-0 p-3 rounded-none bg-primary/5 group-hover:bg-primary/10 transition-colors">
                        {renderIcon(step.iconId)}
                      </div>
                      <div className="space-y-1.5 flex-1">
                        <h3 className="font-serif font-medium text-xl text-foreground group-hover:text-primary transition-colors flex items-center justify-between">
                          {step.title}
                          <ArrowRight className="size-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-primary" />
                        </h3>
                        <p className="text-sm font-sans text-muted-foreground leading-[1.6]">
                          {step.description}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}